import { render, staticRenderFns } from "./OptionClassroomCard.vue?vue&type=template&id=d5f93a96"
import script from "./OptionClassroomCard.vue?vue&type=script&lang=ts"
export * from "./OptionClassroomCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.25_coffee-script@1.12.7_css-loader@5.2.7_webpa_35f4d3d5eaf4581d12c76a04842072e8/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports